export default __webpack_public_path__ + "static/media/verificationfailed.f924da9a.png";